<template>
  <tfoot class="vst-footer">
    <tr class="vst-footer-row">
      <td
        class="vst-footer-cell"
        :class="{ 'vst-sticky': realFixedColsCount > 0 }"
        :style="realFixedColsCount > 0 ? { left: (0 < fixedColsCount ? realStickyOffsets[0] : stickyOffsets[0]) + 'px' } : {}"
      >
        {{ $t('base.total') }}
      </td>
      <td
        v-for="(h, index) in headers.slice(1)"
        :key="h.value"
        class="vst-footer-cell"
        :class="[h.class, h.align && `text-${h.align}`, { 'vst-sticky': index + 1 < realFixedColsCount }]"
        :style="index + 1 < realFixedColsCount ? { left: (index + 1 < fixedColsCount ? realStickyOffsets[index + 1] : stickyOffsets[index + 1]) + 'px' } : {}"
      >
        <slot v-if="$scopedSlots[`total.${h.value}`]" :name="`total.${h.value}`" :value="total[h.value]">
          {{ total[h.value] }}
        </slot>
        <template v-else>{{ getValue(total, h.value) }}</template>
      </td>
    </tr>
  </tfoot>
</template>

<script>
import get from 'lodash/get'
export default {
  name: 'VSTFooter',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    total: {
      type: Object,
      default: () => ({}),
    },
    realFixedColsCount: {
      type: Number,
      required: true,
    },
    fixedColsCount: {
      type: Number,
      required: true,
    },
    realStickyOffsets: {
      type: Array,
      required: true,
    },
    stickyOffsets: {
      type: Array,
      required: true,
    },
    valueMutator: {
      type: Function,
      default: () => null,
    },
  },
  methods: {
    getValue(item, key) {
      const value = get(item, key)
      if (this.valueMutator) {
        return this.valueMutator({
          value,
          item,
          key,
        })
      }
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.vst-footer {
  .vst-footer-row {
    height: 40px;
  }

  .vst-footer-cell {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 10;
    background-color: #f5f7fb;
    color: #343434;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    padding: 0 8px;
    text-align: left;
    white-space: nowrap;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;

    &.vst-sticky {
      z-index: 11;
    }
  }
}
</style>
